shouldPrompt